import store from "@utils/store/localStorage";

import { VUE_APP_API_URL } from "@utils/index";

const LOGIN_KEY = "login_status";
const FWQ = "fwq";
function localStorage() {
  return window.localStorage;
}
const state = {
  footer: true,
  huilv: 6.35,
  home: true,
  homeActive: false,
  token: localStorage().getItem(LOGIN_KEY) || null,
  kf: localStorage().getItem("kf") || "",
  view: localStorage().getItem("view") || "",
  fwq:VUE_APP_API_URL,
  backgroundColor: "#fff",
  userInfo: null,
  storeItems: store.get("storeItems") || null,
  goName: store.get("goName") || ""
};

const mutations = {
  SHOW_FOOTER(state) {
    state.footer = true;
  },
  HUILV(state,data) {
    state.huilv = data;
  },
  HIDE_FOOTER(state) {
    state.footer = false;
  },
  SHOW_HOME(state) {
    state.home = true;
  },
  HIDE_HOME(state) {
    state.home = false;
  },
  OPEN_HOME(state) {
    state.homeActive = true;
  },
  CLOSE_HOME(state) {
    state.homeActive = false;
  },
  SETFWQ(state, datas) {
    console.log("切换成功:");
    state.fwq = datas;
    
    console.log(datas);
  },
  LOGIN(state, datas) {
    state.token = datas.token;
    state.kf = datas.kf;
    state.view = datas.view;
    state.expires_time = datas.expires_time;
    localStorage().setItem(LOGIN_KEY, datas.token);
    localStorage().setItem("kf", datas.kf);
    localStorage().setItem("view", datas.view);
    localStorage().setItem("expires", datas.expires_time);
  },
  SET_KF(state, kf) {
    state.kf = kf || "";
    if (state.kf) {
      localStorage().setItem("kf", state.kf);
    } else {
      localStorage().removeItem("kf");
    }
  },
  Token(state, token) {
    state.token = token;
    localStorage().setItem(LOGIN_KEY,token);

  },
  LOGOUT(state) {
    state.token = undefined;
    localStorage().removeItem(LOGIN_KEY);
  },
  BACKGROUND_COLOR(state, color) {
    state.color = color;
    document.body.style.backgroundColor = color;
  },
  UPDATE_USERINFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  GET_STORE(state, storeItems) {
    state.storeItems = storeItems;
    store.set("storeItems", storeItems);
  },
  GET_TO(state, goName) {
    state.goName = goName;
    store.set("goName", goName);
  }
};
const actions = {};

export default {
  state,
  mutations,
  actions
};

